module.exports = __webpack_public_path__ + "img/PPMP17.10af8003.png";